import React from "react";
import styled from "styled-components";
import { color } from "../../tokens";

interface Props {
  padding?: string;
  margin?: string;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
}

export const Card: React.FC<Props> = (props) => {
  const { padding, margin, width, maxWidth, minWidth } = props;

  return (
    <StyledCard
      $padding={padding}
      $margin={margin}
      $width={width}
      $maxWidth={maxWidth}
      $minWidth={minWidth}
    >
      {props.children}
    </StyledCard>
  );
};

const StyledCard = styled.div<{
  $padding?: string;
  $margin?: string;
  $width?: string;
  $maxWidth?: string;
  $minWidth?: string;
}>`
  background-color: ${color.neutral[100]};
  border-radius: 0.25rem;
  padding: ${(props) => props.$padding || "1rem"};
  margin: ${(props) => props.$margin || "0"};
  width: ${(props) => props.$width || "100%"};
  max-width: ${(props) => props.$maxWidth || "100%"};
  min-width: ${(props) => props.$minWidth || "auto"};
`;
export default Card;
